export default "__VITE_PUBLIC_ASSET__e2eec26c__"